// extracted by mini-css-extract-plugin
export var inner = "Sidebar-module--inner--12iqG";
export var sidebar = "Sidebar-module--sidebar--1NhQN";